import React from 'react';

import ExpLabel from '@exp/components/localization/ExpLabel';

import { TemplateProps } from './types';

import './StaticLayout.less';

const StaticLayout = React.forwardRef<HTMLDivElement, TemplateProps>(
  ({ children = null, onPrevious = null, onSkip = null }, ref) => (
    <div className="exp-modal-static" ref={ref}>
      <div className="exp-modal-header">
        {onPrevious && (
          <button className="exp-onb-back-btn btn-wp-reset" onClick={onPrevious} type="button">
            <i className="exp-ux-small exp-ux-arrow" />
            <ExpLabel defaultMessage="Back" messageKey="onb.qualify.back" />
          </button>
        )}
        {onSkip && (
          <button className="exp-onb-skip-btn btn-wp-reset" onClick={onSkip} type="button">
            <ExpLabel defaultMessage="Skip" messageKey="onb.button.skip" />
          </button>
        )}
      </div>
      <div className="exp-modal-content">{children}</div>
    </div>
  ),
);

StaticLayout.displayName = 'StaticLayout';

export default StaticLayout;
